import { render, staticRenderFns } from "./QuickReferenceIcon.vue?vue&type=template&id=149c8716&scoped=true&"
import script from "./QuickReferenceIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./QuickReferenceIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "149c8716",
  null
  
)

export default component.exports